var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaTurtleHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29394",
    "data-name": "Group 29394",
    transform: "translate(-355 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ninja-turtle",
    transform: "translate(373 353.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50200",
    "data-name": "Path 50200",
    d: "M21.72,16.727a3.914,3.914,0,0,0-2.1-3.114A6.148,6.148,0,0,0,13.388,8a6.148,6.148,0,0,0-6.227,5.613A3.762,3.762,0,0,0,5.1,16.727c0,1.754,1.666,3.245,4.078,4.034a4.949,4.949,0,0,0,4.254,2.149,5.291,5.291,0,0,0,4.254-2.149C20.054,19.972,21.72,18.481,21.72,16.727Z",
    transform: "translate(-5.1 -7.956)",
    fill: "#8bc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50201",
    "data-name": "Path 50201",
    d: "M38.656,11.54a2.688,2.688,0,0,1,.088-2.149A9.345,9.345,0,0,0,39.489,7.9a2.654,2.654,0,0,1,.789,2.456,2.519,2.519,0,0,1-1.754,1.886C38.393,12.373,38.744,12.285,38.656,11.54Z",
    transform: "translate(-23.834 -7.9)",
    fill: "#d32f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50202",
    "data-name": "Path 50202",
    d: "M36.773,11.6a2.778,2.778,0,0,1-.789-2.017A12.945,12.945,0,0,0,36.115,8a2.722,2.722,0,0,1,1.754,1.93,2.472,2.472,0,0,1-.877,2.412C36.861,12.473,37.124,12.21,36.773,11.6Z",
    transform: "translate(-22.433 -7.956)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50203",
    "data-name": "Path 50203",
    d: "M22.261,15.152A5.116,5.116,0,0,0,19.323,14.1c-1.359,0-2.368.789-3.464.789s-2.1-.789-3.464-.789-1.8.132-2.28.658c-.526.526-.614,2.412-.614,2.412a5.592,5.592,0,0,0,2.982.965,4.157,4.157,0,0,1,3.333-1.623,4.575,4.575,0,0,1,3.508,1.666,5.188,5.188,0,0,0,3.026-1.009C22.524,16.687,22.612,15.459,22.261,15.152Z",
    transform: "translate(-7.57 -11.381)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50204",
    "data-name": "Path 50204",
    d: "M13.973,17.1a4.534,4.534,0,0,1,2.456.965c-1.359.307-1.623.789-2.236.833A4.643,4.643,0,0,1,12,18.459,2.534,2.534,0,0,1,13.973,17.1Zm6.49,0a4.534,4.534,0,0,0-2.456.965c1.4.307,1.754.789,2.324.833a4.4,4.4,0,0,0,2.149-.439A2.645,2.645,0,0,0,20.464,17.1Z",
    transform: "translate(-8.974 -13.066)",
    fill: "#efebe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50205",
    "data-name": "Path 50205",
    d: "M22.439,18.9a.6.6,0,0,0-.614.614V19.6a3.023,3.023,0,0,0,.921.351h.132a.609.609,0,0,0,.219-.439A.637.637,0,0,0,22.439,18.9Zm-5.525,0a.6.6,0,0,0-.614.614.54.54,0,0,0,.219.439h.132a3.023,3.023,0,0,0,.921-.351v-.088A.667.667,0,0,0,16.914,18.9Z",
    transform: "translate(-11.388 -14.076)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28953",
    "data-name": "Group 28953",
    transform: "translate(4.254 4.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50206",
    "data-name": "Path 50206",
    d: "M15.151,24.306a9.426,9.426,0,0,0,6.753,0c1.316-.526,1.316.877.219,1.1C16.817,26.192,15.151,24.306,15.151,24.306ZM18.834,19A4.394,4.394,0,0,0,14.8,21.938a4.924,4.924,0,0,1,4.034-2.061,4.828,4.828,0,0,1,4.034,2.017A4.377,4.377,0,0,0,18.834,19Z",
    transform: "translate(-14.8 -19)",
    fill: "#33691e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaTurtleHighlighted);
export default __webpack_public_path__ + "static/media/ninjaTurtleHighlighted.8d79e4cd7c7ff014b4845dcb5cec07b4.svg";
export { ForwardRef as ReactComponent };